/** See `src/i18n/locales/en/documents.ts`. */
export const documents = {
  page: {
    title: 'Dokumente',
    lead: 'Dokumente für {{company}} hochladen und verwalten.',
    noScope: 'Wählen Sie ein Unternehmen, um dessen Dokumente zu sehen.',
    forbidden: 'Sie dürfen die Dokumente dieses Unternehmens nicht sehen.',
  },
  upload: {
    title: 'Dokument hochladen',
    titleField: 'Titel',
    category: 'Kategorie',
    audience: 'Zielgruppe',
    fileUrl: 'Datei-URL',
    file: 'Datei',
    upload_status: {
      uploading: 'Wird hochgeladen…',
      tooLarge: 'Datei ist zu groß (max. 10MB).',
      invalidType: 'Dateityp nicht zulässig.',
    },
    fileUrlHint: 'Wird sofort hochgeladen, oder tragen Sie unten eine bestehende URL ein.',
    requiresReadConfirmation: 'Lesebestätigung erforderlich',
    requiresReadConfirmationHint:
      'Mitarbeiter müssen bestätigen, dass sie dieses Dokument gelesen haben.',
    submit: 'Hochladen',
  },
  categories: {
    algemeen: 'Allgemein',
    beleid: 'Richtlinie',
    veiligheid: 'Sicherheit',
    hr: 'HR',
    vitaliteit: 'Vitalität',
  },
  audiences: {
    iedereen: 'Alle',
    management: 'Management',
    per_afdeling: 'Pro Abteilung',
    per_locatie: 'Pro Standort',
  },
  status: {
    gepubliceerd: 'Veröffentlicht',
    archief: 'Archiviert',
  },
  library: {
    title: 'Dokumentenbibliothek',
    empty: 'Noch keine Dokumente.',
    totalViews: 'Gesamtaufrufe: {{count}}',
    columns: {
      title: 'Titel',
      category: 'Kategorie',
      views: 'Aufrufe',
      status: 'Status',
    },
  },
  actions: {
    new: 'Dokument hochladen',
    cancel: 'Abbrechen',
    publish: 'Veröffentlichen',
    archive: 'Archivieren',
  },
} as const;
